<template>
      <form-group :validator="v" :label="label" :label-for="id" :description="tip">        
        <template slot-scope="{ attrs, listeners }">
            <v-select :id="id"
                :inputId="id"
                :options="options"
                      :reduce="option => option"
                :value="value"
                @input="onSelected"
                aria-label="Search for Department ID" 
                screenreader="Search for Department ID" 
                :data-test="slug"
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                v-on="listeners">
                <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!v.required"
                        v-bind="attributes"
                        v-on="events"
                        :state="v.$dirty ? !v.$error : null"
                        />
                </template>
            </v-select>            
        </template>
      </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"

export default {
    props: {
        value: [String],
        label: [String],
        tip: [String],
        slug: [String],
        v: [Object],
        required: [Boolean]
    },
    data() {
        return {
            options: [ ],
            defaultSelection: ''
        } 
    },
    computed: {
        id() {
            return _.uniqueId('deptSelector')
        },
        isRequired() {
            if (this.required == false) {
                return false
            } else {
                return !this.value.length
            }
        }
    },
    created() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/meta/departments`)
                    .then((values) => {
                        this.options = values.data
                    })
    },
    methods: {
        onSelected(item) {
            this.$emit('input', item)
        },
  }
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
.vs__spinner {
    font-size: 1em;
}
</style>